import { gql } from '@apollo/client';


const AssignOrderError = gql`
    fragment AssignOrderError on JobError {
        errorCode,
        timestamp
    }
`

const AssignOrderData = gql`
    fragment AssignOrderData on JobData {
        timestamp,
        job {
            sequence,
            createdAt,
            order {
                ... on Order {
                    hash,
                    reference,
                    expectedDeliveryTime,
                    hasAlcohol,
                    items {
                      id,
                      name
                    }
                }        
              },
            status
        }
    }
`


export const FRAGMENTS = {
    ASSIGN_ORDER_ERROR: AssignOrderError,
    ASSIGN_ORDER_DATA: AssignOrderData
  };